import StepCard from '../ui/StepCard';

// Section fond clair sky (#EAF4FB) — seule bande claire de la landing.
// Separateur orange en tete (bord franc intentionnel depuis Features sombre).
// Ombre en pied pour "decoller" visuellement de la section sombre suivante.
const WorkflowSection = () => {
  return (
    <section
      id="workflow"
      className="bg-sky shadow-[0_24px_48px_-24px_rgba(14,35,72,0.25)]"
    >
      {/* Separateur pleine largeur orange — signal "etape suivante", bord franc voulu */}
      <div className="h-0.5 w-full bg-accent" aria-hidden="true" />

      <div className="py-20">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-primary-900 mb-4">
              De la première inscription au bulletin, en 4 étapes.
            </h2>
            {/* Barre decorative accent */}
            <div className="w-24 h-1 bg-accent mx-auto rounded-full"></div>
          </div>

          <div className="grid md:grid-cols-4 gap-8 relative">
            {/* Ligne de liaison entre etapes — marine translucide sur fond clair */}
            <div className="hidden md:block absolute top-8 left-[12%] right-[12%] h-px bg-primary/20 -z-0"></div>

            <StepCard
              number="1"
              title="Le parent s'inscrit"
              desc="Créez votre compte, ajoutez votre enfant et sa classe. Quelques minutes suffisent."
            />
            <StepCard
              number="2"
              title="Le répétiteur rejoint"
              desc="Invitez-le par e-mail, ou reliez-le à votre famille grâce à votre code. Il accepte, le suivi commence."
            />
            <StepCard
              number="3"
              title="Le planning se met en place"
              desc="Le répétiteur programme ses cours fixes ; les séances apparaissent automatiquement pour tout le monde."
            />
            <StepCard
              number="4"
              title="Les cours avancent, vous suivez"
              desc="Comptes-rendus après chaque séance, notes saisies, moyennes à jour. La progression devient visible."
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkflowSection;
